/**
 * Use this if you need to access the currently selected "event" on the panel, the value returned
 * changes from layer to layer, for example for Crop Water Use this is a string representing a
 * date, for FHA an object with the date and the type of imagery selected and so on.
 * @param {Object} state
 * @param {Object} props
 * @returns {(Object|String|Number)} the data needed to render the currently selected event.
 * */
export const getCurrentEvent = (state, props) => {
  const view = props.index;
  const currentSeason = state.seasons.activeSeasons[view]?.id;
  const currentLayer = state.layers.activeMapLayers[view]?.id;
  const layerData = state.layers.list[currentSeason]?.[currentLayer];

  if (!layerData) {
    return undefined;
  }

  const currentId =
    layerData.current?.[view] ||
    layerData.activeSubLayerIds?.[view];
  return layerData.byId?.[currentId];
};
